import { createLazyResolver } from 'owa-lazy-resolver';

export const lazyRespondToCalendarEventWeb = createLazyResolver(
    'RESPONDTOMEETINGREQUEST_MUTATION_WEB',
    () => import(/* webpackChunkName: "RespondToCalendarEventWeb" */ './respondToCalendarEventWeb'),
    m => m.respondToCalendarEventWeb
);
